import store from '@/store'
import router from '@/router'
import { Notification } from 'element-ui'

export default {
  _$buffer: null, // 保存错误信息 用于清除上一次
  _$routed: false, // 是否已经跳转过后

  0() {
    this._redirectLogin()
  },

  401() {
    this._notify({ msg: '用户未登录!' })
    store.dispatch('login/logout').then(res => {
      router.replace('/')
    })
  },

  _notify(err) {
    if (this._$buffer) {
      this._$buffer.close()
    }

    if (err.msg) {
      this._$buffer = Notification.error({
        type: 'error',
        title: '提示消息',
        message: err.msg
      })
    }
  },


  _redirectLogin(path) {

    // 如果过期了 那么附带当前路径至登录页 登录后跳转回当前页
    const redirectPath = path || router.history.current.fullPath
    // 防止多个请求失败时多次执行这个方法
    if (this._$routed) return

    // 关闭上一个已有的通知 防止一次性出现多个通知
    if (this._$buffer) {
      this._$buffer.close();

    }

    store.dispatch('login/logout').then(() => {
      this._$buffer = Notification({
        type: 'error',
        title: '提示消息',
        message: '登录信息过期，需要重新登录！'
      });

      // 防止在多个接口请求失败的时候 进行多次跳转以及设置多个重定向目标
      if (!redirectPath.includes('?redirectPath=')) {
        this._$routed = true
        router.replace(`/?redirectPath=${redirectPath}`).then(() => {
          router.go(0)
        })
      }
    })
  }
}